<template>
  <div style="margin-top: 12px;">
    <div>
      <CalculatedOrderItemRow
        v-for="(price, index) in displayItems"
        :key="`${price.itemType}-${index}`"
        :price="price"
        :index="index"
        :mode="mode"
        :editor-mode="editorMode"
        @remove="removePriceItem"
      />
      <CalculatedPayableAmountRow :payable-amount="payableAmount" />
    </div>
  </div>
</template>

<script>
import CalculatedOrderItemRow from './CalculatedOrderItemRow.vue'
import CalculatedPayableAmountRow from './CalculatedPayableAmountRow.vue'

export default {
  name: 'CalculatedOrderListPartial',
  components: {
    CalculatedOrderItemRow,
    CalculatedPayableAmountRow,
  },
  props: {
    priceAdjustments: {
      type: Array,
      default: () => [],
    },
    addonItems: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'edit',
    },
    editorMode: {
      type: String,
      default: 'price',
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    /** 住宿晚數：per_night 加購列金額 = 單價 × 晚數 */
    stayNights: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {}
  },
  watch: {
    payableAmount: {
      handler(newVal) {
        if (newVal !== undefined) {
          this.$emit('update-total', newVal)
        }
      },
      immediate: true,
    },
  },
  computed: {
    displayItems() {
      const priceItems = (this.priceAdjustments || []).map((item) => this.normalizeDisplayItem(item, item.itemType || 'price'))
      const addons = (this.addonItems || []).map((item) => this.normalizeDisplayItem(item, 'addon'))
      return [...priceItems, ...addons]
    },
    payableAmount() {
      const totalAdjustments = this.displayItems.reduce((total, item) => {
        const val = Math.abs(parseFloat(item.amount)) || 0
        const qty = Number(item.qty || item.quantity || 1)
        const finalAmount = this.isNegative(item) ? -val : val
        return total + finalAmount * qty
      }, 0)

      const result = (Number(this.subtotal) || 0) + totalAdjustments
      return result
    },
  },
  methods: {
    normalizeDisplayItem(item, forcedItemType) {
      const itemType = forcedItemType || item.itemType || 'price'
      return {
        ...item,
        itemType,
        type: itemType === 'addon' ? 'add' : item.type,
        reason: this.getDisplayReason(item, itemType),
        amount: this.getDisplayAmount(item, itemType),
        qty: this.getDisplayQty(item),
      }
    },
    getDisplayReason(item, itemType = 'price') {
      if (itemType !== 'addon') {
        return item.reason || item.title || item.goodsName || '-'
      }
      if (item.reason) return item.reason
      const addonName = item.goodsName || item.title || item.name || '-'
      return item.petName ? `${item.petName}｜${addonName}` : addonName
    },
    getDisplayUnitAmount(item) {
      const raw = item.amount != null ? item.amount : item.addonPrice != null ? item.addonPrice : item.unitPrice
      return Math.abs(Number(raw) || 0)
    },
    getDisplayAmount(item, itemType = 'price') {
      const unit = this.getDisplayUnitAmount(item)
      if (itemType === 'addon' && item.billingType === 'per_night') {
        const n = Math.max(1, Number(this.stayNights) || 1)
        return unit * n
      }
      return unit
    },
    getDisplayQty(item) {
      return Number(item.qty || item.quantity || 1)
    },
    isNegative(item) {
      return item.itemType === 'price' && ['discount', 'minus', 'subtract'].includes(item.type)
    },
    removePriceItem(index) {
      if (this.mode === 'live') {
        const current = this.displayItems[index]
        if (!current) return
        if (current.itemType === 'addon') {
          const newAddonItems = [...(this.addonItems || [])]
          const removeIndex = newAddonItems.findIndex((item) => item.petId === current.petId && item.addonId === current.addonId)
          if (removeIndex >= 0) newAddonItems.splice(removeIndex, 1)
          this.$store.commit('hotel/order/SET_ADDONITEMS', newAddonItems)
          return
        }
        const newAdjustments = [...(this.priceAdjustments || [])]
        const removeIndex = newAdjustments.findIndex(
          (item) => item.type === current.type && (item.reason || item.title || '-') === (current.reason || current.title || '-') && Number(item.amount) === Number(current.amount)
        )
        if (removeIndex >= 0) newAdjustments.splice(removeIndex, 1)
        this.$store.commit('hotel/order/SET_PRICEADJUSTMENT', newAdjustments)
      } else {
        this.$emit('removePriceItem', index)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}
::v-deep .el-collapse-item__header {
  height: 80px;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px;
}
</style>
